/**
 * Branding / UI config driven by env (VITE_*).
 * No client-specific assets or texts live in this repo; the parent repo
 * provides them via env and copied assets at build time.
 * Uses direct import.meta.env.VITE_* so Vite replaces them at build time.
 */

export const branding = {
  /** App title (e.g. tab, header) */
  appTitle: import.meta.env.VITE_APP_TITLE ?? "IGA",
  /** Suffix shown after app title in browser tab (e.g. "IGA | Visagio") */
  tabSuffix: import.meta.env.VITE_TAB_SUFFIX ?? "PRR",
  /** Short subtitle or product name under the logo */
  appSubtitle: import.meta.env.VITE_APP_SUBTITLE ?? "INSIGHTS GENERATOR",
  /** Agent display name in chat */
  agentName: import.meta.env.VITE_AGENT_NAME ?? "IGA",
  /** Tagline on empty chat — leave empty to use i18n translation */
  tagline: import.meta.env.VITE_APP_TAGLINE ?? "",
  /** Empty state heading — leave empty to use i18n translation */
  emptyHeading: import.meta.env.VITE_APP_EMPTY_HEADING ?? "",
  /** Favicon path (root-relative). Sync copies parent favicon to both favicon.png and visagio-favicon.png. */
  faviconPath: import.meta.env.VITE_FAVICON_PATH ?? "/PRR-favicon.png",
  /** Logo image path for header/sidebar. */
  logoPath: import.meta.env.VITE_LOGO_PATH ?? "/images/PRR-logo.png",
  /** Agent avatar image in chat bubbles. */
  agentAvatarPath: import.meta.env.VITE_AGENT_AVATAR_PATH ?? "/PRR-favicon.png",
  /** Access denied page - CardDescription message. Leave unset to use i18n translation. */
  accessDeniedMessage: import.meta.env.VITE_ACCESS_DENIED_MESSAGE || undefined,
} as const;

export type Branding = typeof branding;
